import React from "react";
import "./AccordionToggle.css";

type Props = {
  children: React.ReactNode;
  expanded: boolean;
  onClick: () => void;
  doubleChevron?: boolean;
  style?: React.CSSProperties;
  collapsible?: boolean;
  variant?: "primary" | "secondary";
};

const AccordionToggle = ({
  children,
  expanded,
  onClick,
  doubleChevron = false,
  style = {},
  collapsible = true,
  variant = "primary",
}: Props) => {
  const fillColor = variant === "secondary" ? "#313131" : "white";

  return (
    <div
      className="accordion-toggle"
      style={{
        ...style,
      }}
    >
      <div
        id="AcccordionToogleChildren"
        style={{
          display: "flex",
          flexGrow: 1,
        }}
      >
        {children}
      </div>
      <div
        onClick={onClick}
        style={{
          marginLeft: "13px",
        }}
      >
        {collapsible && doubleChevron && (
          <svg
            transform={expanded ? "rotate(180)" : ""}
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.2476 17.0109L10.2287 11.2104C9.81266 10.8095 9.81266 10.1612 10.2287 9.76459L11.2289 8.80069C11.6449 8.39977 12.3176 8.39977 12.7292 8.80069L16.9956 12.9122L21.2619 8.80069C21.678 8.39977 22.3507 8.39977 22.7623 8.80069L23.7713 9.76032C24.1873 10.1612 24.1873 10.8095 23.7713 11.2062L17.7524 17.0067C17.3364 17.4118 16.6636 17.4118 16.2476 17.0109ZM17.7524 25.1998L23.7713 19.3994C24.1873 18.9984 24.1873 18.3502 23.7713 17.9535L22.7711 16.9896C22.3551 16.5887 21.6824 16.5887 21.2708 16.9896L17 21.0969L12.7336 16.9853C12.3176 16.5844 11.6449 16.5844 11.2333 16.9853L10.2287 17.9492C9.81266 18.3502 9.81266 18.9984 10.2287 19.3951L16.2476 25.1956C16.6636 25.6008 17.3364 25.6008 17.7524 25.1998Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17 34C26.3889 34 34 26.3888 34 17C34 7.61117 26.3889 0 17 0C7.61112 0 0 7.61117 0 17C0 26.3888 7.61112 34 17 34ZM17 31.1667C24.824 31.1667 31.1667 24.824 31.1667 17C31.1667 9.17595 24.824 2.83333 17 2.83333C9.17599 2.83333 2.83333 9.17595 2.83333 17C2.83333 24.824 9.17599 31.1667 17 31.1667Z"
              fill={fillColor}
            />
          </svg>
        )}
        {collapsible && !doubleChevron && variant === "primary" && (
          <svg
            transform={expanded ? "rotate(180)" : ""}
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.375 12.0417L25.5 14.1667L17 22.6667L8.5 14.1667L10.625 12.0417L17 18.4167L23.375 12.0417Z"
              fill={fillColor}
            />
            <path
              fillRule="evenodd"
              d="M0 17C0 26.3889 7.61122 34 17 34C26.3888 34 34 26.3889 34 17C34 7.61115 26.3888 0 17 0C7.61122 0 0 7.61115 0 17ZM17 31.1667C9.17597 31.1667 2.83333 24.824 2.83333 17C2.83333 9.17597 9.17597 2.83333 17 2.83333C24.824 2.83333 31.1667 9.17597 31.1667 17C31.1667 24.824 24.824 31.1667 17 31.1667Z"
              fill={fillColor}
            />
          </svg>
        )}
        {variant === "secondary" && (
          <svg
            transform={expanded ? "rotate(180)" : ""}
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.59 0.590088L6 5.17009L1.41 0.590088L0 2.00009L6 8.00009L12 2.00009L10.59 0.590088Z"
              fill="#313131"
            />
            <path
              d="M10.59 0.590088L6 5.17009L1.41 0.590088L0 2.00009L6 8.00009L12 2.00009L10.59 0.590088Z"
              fill="#313131"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default AccordionToggle;
